import { Filter, FilterTypes } from 'components/FilterDrawer/FilterDrawer.config'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns from '../../UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { ITableColumnsType } from 'uikit/tables/default'

export const filtersInitialState: Filter[] = [
  {
    type: FilterTypes.CHIPS,
    name: 'overviewDetails.industry',
    label: 'Industry',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'entityDetails.location',
    label: 'Headquarters Location',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'totals.jurisdictions',
    label: 'Jurisdictions',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'totals.localDepartments',
    label: 'Local Departments',
    value: [],
  },
]

export const companyOverviewColumns: ITableColumnsType<any> = [
  { ...columns[COLUMNS_IDS.verifiedName], fixed: 'left' as const, minWidth: 155, title: 'Business Name' },
  columns[COLUMNS_IDS.companyIndustry],
  columns[COLUMNS_IDS.companyFounded],
  { ...columns[COLUMNS_IDS.locations], title: 'Main Site' },
  columns[COLUMNS_IDS.companyLocations],
  columns[COLUMNS_IDS.companyEmployeesLocal],
  columns[COLUMNS_IDS.companyEmployeesLocalPercent],
  columns[COLUMNS_IDS.companyEmployeesAbroad],
  columns[COLUMNS_IDS.companyEmployeesAbroadPercent],
  columns[COLUMNS_IDS.companyExecutivesLocal],
  columns[COLUMNS_IDS.companyExecutivesLocalPercent],
  columns[COLUMNS_IDS.companyExecutivesAbroad],
  columns[COLUMNS_IDS.companyExecutivesAbroadPercent],
  columns[COLUMNS_IDS.nonRnDLocal],
  columns[COLUMNS_IDS.nonRnDLocalPercent],
  columns[COLUMNS_IDS.rndLocal],
  columns[COLUMNS_IDS.rndLocalPercent],
  columns[COLUMNS_IDS.localDepartments],
  columns[COLUMNS_IDS.dataSources],
  columns[COLUMNS_IDS.entityType],
  columns[COLUMNS_IDS.caseId],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  companyOverviewColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
